import { DepletionCurveGraphData, IPRGraphData } from "../../store/model/calculations/calculation";
import { LABELS } from "../labels/jetlift/jetlift.labels";

export const defaultTubingWeight = [
    { value: "1.66", label: "" },
    { value: "1.9", label: "" },
    { value: "2.375", label: "4.7" },
    { value: "2.875", label: "6.5" },
    { value: "3.5", label: "9.3" },
];

export const yesNo = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
];

export const defaultIPRData: IPRGraphData = {
    wiggins: [],
    vogel: [],
    constantPi: [],
    compositePi: [],
    x_Plot_MaxValue: 0,
    y_PlotMaxValue: 0,
    x_Plot_Interval: 0,
    y_Plot_Interval: 0,
};

export const defaultDepletionData: DepletionCurveGraphData = {
    wiggins: [],
    depletion10Percent: [],
    depletion20Percent: [],
    depletion30Percent: [],
    depletion40Percent: [],
    depletion50Percent: [],
    depletion60Percent: [],
    depletion70Percent: [],
    generalDepletion: [],
    x_Plot_MaxValue: 0,
    y_Plot_MaxValue: 0,
    x_Plot_Interval: 0,
    y_Plot_Interval: 0,
};

export const tableColumns: any = [
    {
        title: "",
        dataIndex: "label",
        key: "label",
        sortable: false,
        width: "55%",
    },
    {
        title: "",
        dataIndex: "Q0",
        key: "Q0",
        sortable: false,
        width: "25%",
    },
];

export const columns = [
    {
        title: "",
        dataIndex: "label",
        key: "label",
        sortable: false,
        width: "40%",
    },
    {
        title: "",
        dataIndex: "value1",
        key: "value1",
        sortable: false,
        width: "15%",
    },
    {
        title: "",
        dataIndex: "value2",
        key: "value2",
        sortable: false,
        width: "15%",
    },
    {
        title: "",
        dataIndex: "value3",
        key: "value3",
        sortable: false,
        width: "15%",
    },
    {
        title: "",
        dataIndex: "value4",
        key: "value4",
        sortable: false,
        width: "15%",
    },
];

export const inflowType = {
    "PI": "0",
    "Pressure": "1"
};

export const suplPwrList = {
    "0": "Distribution",
    "1": "Generator"
};

export const cntrlList = {
    "0": "Soft-Start",
    "1": "SWB",
    "2": "VSD"
};

export const powerFluidTypeList = {
    "Water Power Fluid": "1",
    "Oil Power Fluid": "2"
};

export const manufactureList = {
    "1": "SLB_PetroLift",
    "2": "OilMaster",
    "3": "Kobe_National",
    "4": "WRFD_Guiberson"
};

export const comparisonCase1Columns = [
    {
        title: "",
        dataIndex: "label",
        key: "label",
        sortable: false,
        width: "50%",
    },
    {
        title: `${LABELS?.case1}`,
        dataIndex: "value1",
        key: "value1",
        sortable: false,
        width: "50%",
    },
];

export const comparisonCase2Columns = [
    {
        title: "",
        dataIndex: "label",
        key: "label",
        sortable: false,
        width: "50%",
    },
    {
        title: `${LABELS?.case1}`,
        dataIndex: "value1",
        key: "value1",
        sortable: false,
        width: "25%",
    },
    {
        title: `${LABELS?.case2}`,
        dataIndex: "value2",
        key: "value2",
        sortable: false,
        width: "25%",
    },
];

export const comparisonCase3Columns = [
    {
        title: "",
        dataIndex: "label",
        key: "label",
        sortable: false,
        width: "40%",
    },
    {
        title: `${LABELS?.case1}`,
        dataIndex: "value1",
        key: "value1",
        sortable: false,
        width: "20%",
    },
    {
        title: `${LABELS?.case2}`,
        dataIndex: "value2",
        key: "value2",
        sortable: false,
        width: "20%",
    },
    {
        title: `${LABELS?.case3}`,
        dataIndex: "value3",
        key: "value3",
        sortable: false,
        width: "20%",
    },
];

export const tabs = ['Well depths', 'Well / IPR @Datum', 'Operating performance', 'Fluid properties', 'Chemical injection performance'];